<template>
  <div class="asd-insurance container-fluid">

    <div class="row">
      <div class="col s12">
        <table class="">
          <tr>
            <th>ID</th>
            <td>{{ insurance.id }}</td>
          </tr>
          <tr>
            <th>Nome</th>
            <td>{{ insurance.title }}</td>
          </tr>
          <tr>
            <th>Numero polizza</th>
            <td>{{ insurance.code }}</td>
          </tr>
          <tr>
            <th>Categoria</th>
            <td>{{ insurance.type_name }}</td>
          </tr>
          <tr>
            <th>Inizio Validità</th>
            <td>{{ new Date(insurance.valid_from).toLocaleDateString('it-IT') }}</td>
          </tr>
          <tr>
            <th>Fine Validità</th>
            <td>{{ new Date(insurance.valid_to).toLocaleDateString('it-IT') }}</td>
          </tr>
          <tr>
            <th>Verificato</th>
            <td>
              <span v-html="verifiedStatus(insurance.verified)" />
              <button v-if="validation === 1"
                      type="button" class="btn blue right" @click="validate(insurance.id)">Certifica</button>
            </td>
          </tr>
<!--          <tr>-->
<!--            <th>Stato</th>-->
<!--            <td>{{ insurance.published }}</td>-->
<!--          </tr>-->
        </table>
      </div>
      <div class="col s12">
        <DirectoryManager
            ref="dirMan"
            v-if="insurance !== null"
            :key="insurance.id"
            :insurance="insurance"
        >
          <template v-slot:exit>
            <button type="button" class="btn red" @click="close">Chiudi</button>
            <button type="button" class="btn black" @click="deleteInsurance">Elimina</button>
          </template>
        </DirectoryManager>
      </div>
    </div>

  </div>

</template>

<script>
export default {
  name: "AsdInsurance",

  props: {
    insurance: {
      required: true,
      type: Object,
    },
    validation: {
      required: true,
      type: Number
    }
  },

  methods: {
    close: function() {
      this.$emit('close');
    },

    validate: function(id) {
      console.log("il mio id", id, 'il tuo id', this.insurance)
      if (window.confirm('Vuoi certificare e BLOCCARE questa assicurazione? Questa azione non è reversibile, e ogni futura modifica sarà impedita.')) {
        window.axios({
          method: 'put',
          url: '/index.php?option=com_api&app=asdgest&resource=insurance',
          data: {
            insurance_id: this.insurance.id
          }
        })
          .then( response => {
            if (response.data.ok === true) {
              alert('Certificazione eseguita. La pagina verrà ricaricata');
              window.location.reload(true);
            } else {
              alert(response.data.message);
            }
          })
          .catch( console.log );
      } else {
        console.log('Certificazione annullata');
      }
    },

    deleteInsurance: function() {
      if (window.confirm('Vuoi eliminmare questa assicurazione e tutti i suoi file? Questa azione non è reversibile.')) {
        window.axios({
          method: 'delete',
          url: '/index.php?option=com_api&app=asdgest&resource=insurance',
          data: {
            insurance_id: this.insurance.id
          }
        })
            .then( response => {
              if (response.data.ok === true) {
                alert('Eliminazione eseguita. La pagina verrà ricaricata');
                window.location.reload(true);
              } else {
                alert(response.data.message);
              }
            })
            .catch( console.log );
      } else {
        console.log('Eliminazione annullata');
      }
    },

    verifiedStatus: function(status) {
      switch(status) {
        case '1':
          return 'Verificato';
        case '0':
          return 'In attesa di verifica';
        default:
          return '??';
      }
    }
  }
}
</script>

<style scoped>

</style>
